import {
  TextField,
  Button,
  Box,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { buttonPrimaryStyles } from "../../styles/ComponentStyles";
import StatusMessage from "./StatusMessage";

export default function LoginForm({
  translate,
  email,
  setEmail,
  password,
  setPassword,
  remember,
  setRemember,
  loading,
  showError,
  statusMessage,
  onSubmit,
  onForgot,
}) {
  return (
    <form onSubmit={onSubmit} style={{ width: "100%", maxWidth: 350 }}>
      <TextField
        label={translate("email")}
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        error={showError && !email}
        helperText={showError && !email ? translate("email_error") : ""}
      />

      <TextField
        label={translate("password")}
        type="password"
        fullWidth
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        error={showError && !password}
        helperText={showError && !password ? translate("password_error") : ""}
      />

      <Box
        sx={{ textAlign: "right", mt: 1, cursor: "pointer" }}
        onClick={onForgot}
      >
        {translate("forgot_password")}
      </Box>

      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={loading}
        sx={{ ...buttonPrimaryStyles, mt: 1 }}
      >
        {loading ? translate("logging_in") : translate("login")}
      </Button>

      <StatusMessage message={statusMessage} />

      <FormControlLabel
        control={
          <Checkbox
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          />
        }
        label={translate("remember_me")}
        sx={{ mt: 1 }}
      />
    </form>
  );
}
